// 비전 및 미션 페이지
import React from 'react'
import styled from 'styled-components'
import { MenuContainer } from '../../components/menuContainer/MenuContainer'
import { motion } from 'framer-motion' // Framer Motion 사용 (MIT 라이선스)

const Image = styled.img`
  @media (max-width: 991px) {
    width: 50px;
    height: auto;
  }
  @media (max-width: 767px) {
    width: 40px;
  }
  @media (max-width: 575px) {
    width: 30px;
  }
`

const H4 = styled.h4`
  margin-left: 80px;
  margin-bottom: 0;

  @media (max-width: 1199px) {
    margin-left: 60px;
  }
  @media (max-width: 991px) {
    margin-left: 20px;
    font-size: 18px;
  }
`

const P = styled.p`
  font-size: 22px;
  margin: 0;
  line-height: 2;
  font-weight: bold;
  @media (max-width: 991px) {
    font-size: 16px;
  }
  @media (max-width: 767px) {
    margin-top: 10px;
    padding: 0;
  }
  @media (max-width: 380px) {
    font-size: 14px;
  }
`

export const Vision = () => {
  return (
    <MenuContainer title="회사소개" menu="비전 및 미션" pointRadius="50%">
      <div className="comment-wrapper">
        <motion.div
          className="comment"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          "서진로지텍은 변화에 대응하며,&nbsp;
          <span className="d-block d-md-none" />
          최고 수준의 물류 서비스로 신뢰받는 기업이 되겠습니다."
        </motion.div>
        <motion.div
          className="detailed-comment"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: false }}
          transition={{
            ease: 'easeInOut',
            duration: 1,
            y: { duration: 0.5 },
          }}
        >
          정직과 정도 경영을 바탕으로 고객의 요구를 충족하며,
          <span className="d-block d-md-none" /> 혁신과 효율성으로
          <br />
          경쟁력을 확보하고 물류 산업을 선도하겠습니다.
        </motion.div>
      </div>
      <motion.div
        initial={{ opacity: 0, y: 100 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: false }}
        transition={{
          ease: 'easeInOut',
          duration: 1,
          y: { duration: 0.5 },
        }}
      >
        <div>
          <div id="companyMotto" className="row skyblue-block">
            <div className="d-flex col-12 col-md-5 align-items-center">
              <Image src="/motto-icon.png" alt="icon" width={80} />
              <H4 className="d-flex align-items-center justify-content-center fw-bold">
                사훈
              </H4>
            </div>
            <div className="d-flex align-items-center col-12 col-md-7">
              <P>정직과 정도 경영으로 고객에게 신뢰받는 회사</P>
            </div>
          </div>
          <div id="pursuingCoreValues" className="row skyblue-block">
            <div className="d-flex col-12 col-md-5 align-items-center">
              <Image src="/pursuingCoreValues-icon.png" alt="icon" width={80} />
              <H4 className="d-flex align-items-center justify-content-center fw-bold">
                핵심 가치 추구
              </H4>
            </div>
            <div className="d-flex align-items-center col-12 col-md-7">
              <P>
                원칙 | 화합과 혁신
                <br />
                문화 | Team Work & Ownership
                <br />
                인재 | 솔선수범 및 도전과 창조의식 배양
              </P>
            </div>
          </div>
          <div id="Vision" className="row skyblue-block">
            <div className="d-flex col-12 col-md-5 align-items-center">
              <Image src="/vision-icon.png" alt="icon" width={80} />
              <H4 className="d-flex align-items-center justify-content-center fw-bold">
                Vision
              </H4>
            </div>
            <div className="d-flex align-items-center col-12 col-md-7">
              <P>
                최고수준의 종합물류 서비스로 고객만족도 UP
                <br />
                고품질 서비스 및 효율화로
                <br />
                지속적인 경쟁 우위 확보
              </P>
            </div>
          </div>
          <div id="Mission" className="row skyblue-block">
            <div className="d-flex col-12 col-md-5 align-items-center">
              <Image src="/mission-icon.png" alt="icon" width={80} />
              <H4 className="d-flex align-items-center justify-content-center fw-bold">
                Mission
              </H4>
            </div>
            <div className="d-flex align-items-center col-12 col-md-7">
              <P>
                협력사와 시너지 관계 구축
                <br />
                고효율 품질향상으로 경쟁우위 확보
                <br />
                조직의 유연성 및 핵심 역량 축적
              </P>
            </div>
          </div>
        </div>
      </motion.div>
    </MenuContainer>
  )
}
